import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-payouts-export-modal',
    templateUrl: './payouts-export-modal.component.html',
    styleUrls: ['./payouts-export-modal.component.scss'],
})
export class PayoutsExportModalComponent implements OnInit {
    success = true;
    constructor(
        public dialogRef: MatDialogRef<PayoutsExportModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any
    ) {}

    ngOnInit(): void {
        // console.log(this.data);
        this.success = this.data.success;
    }

    close() {
        this.dialogRef.close();
    }

    export(action: boolean) {
        this.dialogRef.close(action);
    }
}
